// extracted by mini-css-extract-plugin
export default {"LastUpdateData":"LastUpdateData_LastUpdateData__PUF5K","Title":"LastUpdateData_Title__DQeWz","Data":"LastUpdateData_Data__kToZr"};